/* Just Silver - quiet-luxury concept: tabs, rail arrows and scroll reveals.
   Everything is an enhancement. Without this file the tabs show their first
   panel, rails still swipe and every section is visible. */
(function () {
  'use strict';

  var w = window;
  var d = document;
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(w.Shopify && w.Shopify.designMode);
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  /* ---- the Shopify Forms pop-up is not part of this design ----
     The Forms app injects its pop-up from the store, not from the theme, so a
     theme setting cannot switch it off. This removes the app's host element
     the moment it appears. To bring the pop-up back, delete this block. */
  var dropForms = function (n) {
    if (n && n.nodeType === 1 && n.tagName === 'SHOPIFY-FORMS-EMBED') n.remove();
  };
  each(d.querySelectorAll('shopify-forms-embed'), dropForms);
  new MutationObserver(function (list) {
    each(list, function (m) { each(m.addedNodes, dropForms); });
  }).observe(d.documentElement, { childList: true, subtree: true });

  /* ---- product tabs + rail arrows ---- */
  if (!customElements.get('jsq-tabs')) {
    customElements.define('jsq-tabs', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.prototype.slice.call(this.querySelectorAll('.jsq-tabs__panel'));
        this.nav = this.querySelectorAll('.jsq-rail-nav button');
        this.i = 0;

        this.tabs.forEach(function (t, k) {
          t.addEventListener('click', function () { self.select(k); });
          t.addEventListener('keydown', function (e) {
            var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
            if (!dir) return;
            e.preventDefault();
            self.select((self.i + dir + self.tabs.length) % self.tabs.length, true);
          });
        });

        each(this.nav, function (b) {
          b.addEventListener('click', function () {
            var rail = self.rail();
            if (!rail) return;
            var step = rail.clientWidth * 0.8 * (+b.getAttribute('data-dir'));
            rail.scrollBy({ left: step, behavior: reduce ? 'auto' : 'smooth' });
          });
        });

        this.panels.forEach(function (p) {
          var r = p.querySelector('.jsq-rail');
          if (r) r.addEventListener('scroll', function () { self.updateNav(); }, { passive: true });
        });
        w.addEventListener('resize', function () { self.updateNav(); });
        this.updateNav();
      }

      rail() {
        var p = this.panels[this.i];
        return p ? p.querySelector('.jsq-rail') : null;
      }

      updateNav() {
        var r = this.rail();
        if (!r || !this.nav.length) return;
        var max = r.scrollWidth - r.clientWidth;
        this.nav[0].disabled = r.scrollLeft <= 4;
        this.nav[1].disabled = r.scrollLeft >= max - 4;
      }

      select(k, focus) {
        if (k === this.i) return;
        var from = this.panels[this.i];
        var to = this.panels[k];
        this.tabs.forEach(function (t, n) {
          t.setAttribute('aria-selected', n === k ? 'true' : 'false');
          t.tabIndex = n === k ? 0 : -1;
        });
        if (focus) this.tabs[k].focus();
        this.i = k;
        if (from) from.hidden = true;
        if (to) {
          to.hidden = false;
          to.classList.remove('is-entering');
          void to.offsetWidth;
          to.classList.add('is-entering');
          var r = to.querySelector('.jsq-rail');
          if (r) { r.scrollLeft = 0; r.classList.add('is-in'); }
        }
        this.updateNav();
      }
    });
  }

  /* ---- a vertical mouse wheel over a rail scrolls the page, not the rail
     (same reason as the theme's wheel-scroll-fix.js for its sliders) ---- */
  d.addEventListener('wheel', function (e) {
    var rail = e.target.closest && e.target.closest('.jsq-rail');
    if (!rail || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    e.preventDefault();
    w.scrollBy({ top: e.deltaY, left: 0, behavior: 'auto' });
  }, { passive: false });

  /* ---- hide the cart badge while the bag is empty ---- */
  var syncCount = function () {
    each(d.querySelectorAll('.header__cart-count'), function (c) {
      c.toggleAttribute('data-jsq-empty', c.textContent.trim() === '0');
    });
  };
  syncCount();
  var hdr = d.querySelector('.header__right') || d.querySelector('.header');
  if (hdr) new MutationObserver(syncCount).observe(hdr, { childList: true, subtree: true, characterData: true });

  /* ---- scroll reveals: only for things that start below the fold ---- */
  if (reduce || design || !('IntersectionObserver' in w)) return;
  var fold = w.innerHeight * 0.92;
  var marked = [];
  // measure everything first, then mark (29 Oct 2026): marking between
  // measurements made the browser lay the page out again for each element
  var shown = [];
  each(d.querySelectorAll('[data-jsq-reveal]'), function (el) {
    var r = el.getBoundingClientRect();
    if (r.top < fold || (r.width === 0 && r.height === 0)) shown.push(el);
    else marked.push(el);
  });
  shown.forEach(function (el) { el.classList.add('is-in'); });
  // everything above the fold is shown before the first paint of the style
  d.documentElement.classList.add('jsq-ready');
  if (!marked.length) return;

  var heard = false;
  var io = new IntersectionObserver(function (entries) {
    heard = true;
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
  marked.forEach(function (el) { io.observe(el); });
  setTimeout(function () {
    if (!heard) { marked.forEach(function (el) { el.classList.add('is-in'); }); io.disconnect(); }
  }, 3000);
  w.addEventListener('beforeprint', function () {
    marked.forEach(function (el) { el.classList.add('is-in'); });
  });
})();
